import {Hydra} from '../generic/hydra';

import {Personne as PersonneBaseInterface} from '../../interface/api/Personne';

export type PersonneInterface = PersonneBaseInterface;

export class Personne extends Hydra implements PersonneInterface {

    id?: number | null;

    titre?: string | null;

    civilite?: string | null;

    nom?: string | null;

    nomNaissance?: string | null;

    prenom?: string | null;


    constructor(options: PersonneInterface = null) {
        super();
        if(options) {
            Object.assign(this, options);
        }
    }

}
